import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, bootstrapMsal } from "./services/msal";
import App from './App';

const rootElement = document.getElementById('root') as any;
const root = createRoot(rootElement);

// Don’t render anything that touches MSAL before the async bootstrap finishes
// Bootstrap async flow: initialize -> handle redirect -> render
(async () => {

    try {
        await bootstrapMsal();
    } catch (err) {
        console.error("MSAL bootstrap failed:", err);
        rootElement.innerHTML = `<div style="padding:24px;color:crimson">
        Authentication initialization failed. Please refresh or contact support.
    </div>`;
        return;
    }

    root.render(
        <MsalProvider instance={msalInstance}>
            <BrowserRouter basename="/">
                <App />
            </BrowserRouter>
        </MsalProvider>
    );
})();